import React from "react";
import Footer from "../../app/landing/Footer";
import { LogoIcon } from "../../design-system";
import { APP_DOMAIN } from '../../core/utils/config';
import { logoFontStyle } from "../../design-system/brand/logoFont";

const NotFoundWebsite = ({ username, domain }) => {
  const filteredUsername = username ? username : "";
  const filteredDomain = domain ? domain : "";
  const usernameAndDomain = [filteredUsername, filteredDomain]
    .filter(Boolean)
    .join("/");

  const message = usernameAndDomain
    ? `Website "${usernameAndDomain}" not found`
    : "Website not found";

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center text-blue-800 p-8">
        {/* Logo */}
        <div className="mb-8">
          <LogoIcon className="w-24 h-24" color="#60a5fa" />
        </div>

        {/* Branding */}
        <div className="mb-8 text-center">
          <a href="/" className="inline-block">
            <h1 className="text-6xl sm:text-7xl font-bold text-blue-600 mb-2" style={logoFontStyle}>
              {APP_DOMAIN}<sup className="text-3xl">®</sup>
            </h1>
          </a>
        </div>

        {/* Message */}
        <div className="text-center max-w-2xl">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-blue-600 mb-6">{message}</h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            The website you're looking for does not exist yet. Please check back soon...{' '}
            <a href="/" className="font-semibold text-blue-600 underline">
              or be the one to create it!
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFoundWebsite;
